/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Menu_Guide_HintInputs */



/**
* | output |
* | --- |
* | "Set up, read the charts, run levelling" |
*
* @param {Marketing_Menu_Guide_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const marketing_menu_guide_hint = /** @type {((inputs?: Marketing_Menu_Guide_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Menu_Guide_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка, чтение графиков, работа с уровнями")
	return /** @type {LocalizedString} */ ("Set up, read the charts, run levelling")
});